<fa-icon
  [icon]="icon"
  [ngClass]="[size]"
  [style.color]="color"
  [attr.data-hover]="isHover"
></fa-icon>
